
import axios from 'axios';

const Baseurl = (
  process.env.REACT_APP_API_BASE_URL || ''
).replace(/\/+$/, '');

const tenant = (
  process.env.REACT_APP_KIOSK_TENANT ||
  window.location.hostname.split('.')[0]
).toLowerCase();

console.log('Kiosk Gateway Base URL:', Baseurl);
console.log('Kiosk Tenant:', tenant);

const kioskApi = axios.create({
  baseURL: `${Baseurl}/api/kiosk`,
  timeout: 30000,
  params: {
    tenant,
  },
});

const errorHandler = (error) => {
  const language = localStorage.getItem('language');

  if (error?.response?.data?.message) {
    return {
      data: null,
      error: error.response.data.message,
    };
  }

  if (error?.response?.status === 401) {
    return {
      data: null,
      error:
        language === '1'
          ? 'Error de validacion.'
          : 'Validation Error.',
    };
  }

  return {
    data: null,
    error:
      language === '1'
        ? 'Algo salió mal.'
        : 'Something went wrong.',
  };
};

export const getToken = async (offenderId) => {
  try {
    const response = await kioskApi.get('/validate-user', {
      params: {
        offenderNumber: offenderId,
      },
    });

    return {
      data: response.data,
      error: null,
    };
  } catch (err) {
    return errorHandler(err);
  }
};

export const validateParticipant = async (
  dob,
  participantId,
  token
) => {
  const language = localStorage.getItem('language');

  try {
    const response = await kioskApi.get(
      '/validate-participant',
      {
        params: {
          participantId,
          birthdate: dob,
        },
      }
    );

    const data = response.data;

    if (!data?.success) {
      return {
        data: null,
        error:
          language === '1'
            ? 'Fecha de nacimiento invalida.'
            : 'Invalid Date of Birth.',
      };
    }

    return {
      data,
      error: null,
    };
  } catch (err) {
    return errorHandler(err);
  }
};

export const getQuestions = async () => {
  try {
    const response = await kioskApi.get(
      '/get-all-questions'
    );

    return {
      data: response.data,
      error: null,
    };
  } catch (err) {
    return errorHandler(err);
  }
};

export const sendQuestionAnswers = async (
  questionAnswers
) => {
  const language = localStorage.getItem('language');

  const sessionId = localStorage.getItem('sessionId');
  const personId = localStorage.getItem('personId');

  try {
    const response = await kioskApi.post('/check-in', {
      sessionId,
      personId,
      ...questionAnswers,
    });

    const data = response.data;

    if (!data?.success) {
      return {
        data: null,
        error:
          language === '1'
            ? 'Algo salió mal.'
            : 'Something went wrong.',
      };
    }

    return {
      data,
      error: null,
    };
  } catch (err) {
    return errorHandler(err);
  }
};
export const drugTestCheckIn = async () => {
  const language = localStorage.getItem('language');

  const sessionId = localStorage.getItem('sessionId');
  const personId = localStorage.getItem('personId');

  try {
    const response = await kioskApi.post(
      '/drug-test-check-in',
      {
        sessionId,
        personId,
      }
    );

    const data = response.data;

    if (!data?.success) {
      return {
        data: null,
        error:
          language === '1'
            ? 'Algo salió mal.'
            : 'Something went wrong.',
      };
    }

    return {
      data,
      error: null,
    };
  } catch (err) {
    return errorHandler(err);
  }
};
